import { UAParser } from 'ua-parser-js';

export const parseUserAgent = () => {
  if (typeof navigator === 'undefined') {
    return {};
  }

  const { os, browser, device } = UAParser(navigator.userAgent);

  return {
    osName: os.name,
    osVersion: os.version,
    os: `${os.name} ${os.version}`,
    deviceType: transformDeviceType(device.type),
    browserName: browser.name,
    browserVersion: browser.version,
    browser: `${browser.name} ${browser.version}`,
  };
};

export function getDeviceTypeByAgent(agent: string) {
  if (agent.includes('InflearnMobile')) {
    return 'mobile';
  }

  const { device } = UAParser(agent);
  return transformDeviceType(device.type);
}

function transformDeviceType(deviceType?: string) {
  switch (deviceType) {
    case 'mobile':
      return 'mobile';
    case 'tablet':
      return 'tablet';
    case 'desktop':
      return 'desktop';
    default:
      return 'desktop';
  }
}
